module.exports = __webpack_public_path__ + "img/macbook-pro.fbbe4299.png";